import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import { formatDate } from 'helpers/helpers'
import { GET, httpOk } from 'helpers/api'

export const QUICK_FILTERS = [
	{ id: 'week', key: 'filter_7days' },
	{ id: 'month', key: 'filter_30days' },
	{ id: 'quarter', key: 'filter_90days' },
	{ id: 'year', key: 'filter_year' },
]

export function getDateRange(id) {
	const now = new Date()
	const fmt = d => formatDate(d, 'yyyy-MM-dd')
	const back = n => { const d = new Date(now); d.setDate(d.getDate() - n); return d }
	if (id === 'week') return { start: fmt(back(6)), end: fmt(now) }
	if (id === 'quarter') return { start: fmt(back(89)), end: fmt(now) }
	if (id === 'year') return { start: fmt(back(364)), end: fmt(now) }
	return { start: fmt(back(29)), end: fmt(now) }
}

// mln/mlrd/ming — son qisqartmasi
export const mln = (v) => {
	v = Number(v) || 0
	const a = Math.abs(v)
	if (a >= 1e9) return (v / 1e9).toFixed(1) + ' mlrd'
	if (a >= 1e6) return (v / 1e6).toFixed(1) + ' mln'
	if (a >= 1e3) return Math.round(v / 1e3) + ' ming'
	return String(Math.round(v))
}

// Sana filtri qatori
export function FilterBar({ quick, custom, onQuick, onCustom, t }) {
	return (
		<div className="ta-filter">
			<div className="ta-chips">
				{QUICK_FILTERS.map(f => (
					<button key={f.id} className={'ta-chip' + (quick === f.id ? ' on' : '')} onClick={() => onQuick(f.id)}>{t(f.key)}</button>
				))}
			</div>
			<DatePicker selectsRange startDate={custom.start} endDate={custom.end} dateFormat="dd.MM.yyyy"
				className="ta-dp" placeholderText={t('select_date')} isClearable
				onChange={([s, e]) => onCustom(s, e)} />
		</div>
	)
}

// ABC rang
export const ABC_COLOR = { A: '#16a34a', B: '#f59e0b', C: '#ef4444' }

// Kategoriya karta ranglari (A/B/C)
export const ABC_CAT = {
	A: { bg: '#f0fdf4', bd: '#bbf7d0', color: '#15803d', sub: 'cat_critical' },
	B: { bg: '#fffbeb', bd: '#fde68a', color: '#b45309', sub: 'cat_important' },
	C: { bg: '#fef2f2', bd: '#fecaca', color: '#b91c1c', sub: 'cat_low' },
}

// XYZ ranglari (talab barqarorligi)
export const XYZ_COLOR = { X: '#16a34a', Y: '#f59e0b', Z: '#ef4444', '-': '#94a3b8' }
export const XYZ_CAT = {
	X: { bg: '#f0fdf4', bd: '#bbf7d0', color: '#15803d', sub: 'xyz_stable' },
	Y: { bg: '#fffbeb', bd: '#fde68a', color: '#b45309', sub: 'xyz_variable' },
	Z: { bg: '#fef2f2', bd: '#fecaca', color: '#b91c1c', sub: 'xyz_irregular' },
}

// Bo'lim tanlagich — bo'limlar tenant bo'yicha dinamik yuklanadi (products_types)
export function DeptSelect({ value, onChange, t }) {
	const [opts, setOpts] = useState([])
	useEffect(() => {
		let alive = true
		GET('/analytics/departments', {}, {}).then(res => { if (alive && httpOk(res)) setOpts(res.data) })
		return () => { alive = false }
	}, [])
	if (opts.length === 0) return null
	return (
		<select className="ta-sel" value={value} onChange={e => onChange(e.target.value)}>
			<option value="">{t('all_depts')}</option>
			{opts.map(d => <option key={d.id} value={String(d.id)}>{d.name}</option>)}
		</select>
	)
}

export const TA_CSS = `
.ta{font-family:"Plus Jakarta Sans","Segoe UI",system-ui,sans-serif;padding:2px}
.ta-head{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px;margin-bottom:16px}
.ta-head h4{margin:0;font-weight:800;font-size:20px;color:#0f172a}
.ta-head .ta-hint{font-size:13px;color:#64748b;margin-top:3px;font-weight:500}
.ta-filter{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
.ta-chips{display:flex;background:#f1f5f9;border-radius:10px;padding:3px;gap:2px}
.ta-chip{border:0;background:transparent;color:#64748b;font:inherit;font-size:13px;font-weight:600;padding:6px 12px;border-radius:8px;cursor:pointer;white-space:nowrap}
.ta-chip:hover{color:#0f172a}
.ta-chip.on{background:#fff;color:#0f172a;box-shadow:0 1px 2px rgba(15,23,42,.1)}
.ta-dp{width:190px;border:1px solid #e2e8f0;border-radius:9px;padding:7px 11px;font-size:13px;color:#0f172a;font-family:var(--mono,inherit)}
.ta-cards{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:12px;margin-bottom:18px}
.ta-card{background:#fff;border:1px solid #eef2f7;border-radius:14px;padding:16px 18px;box-shadow:0 1px 2px rgba(15,23,42,.04)}
.ta-card-v{font-size:23px;font-weight:800;color:#0f172a;line-height:1.1}
.ta-card-l{font-size:12.5px;color:#64748b;margin-top:4px;font-weight:600}
.ta-block{background:#fff;border:1px solid #eef2f7;border-radius:14px;margin-bottom:16px;overflow:hidden;box-shadow:0 1px 2px rgba(15,23,42,.04)}
.ta-block-h{padding:14px 18px;border-bottom:1px solid #f1f5f9;font-size:15px;font-weight:800;color:#0f172a;display:flex;align-items:center;gap:8px}
.ta-scroll{overflow-x:auto}
.ta-tbl{width:100%;border-collapse:collapse;font-size:13.5px}
.ta-tbl th{background:#f8fafc;text-align:left;padding:10px 16px;font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:#64748b;font-weight:700;border-bottom:1px solid #eef2f7;white-space:nowrap}
.ta-tbl td{padding:10px 16px;border-bottom:1px solid #f1f5f9;color:#0f172a;white-space:nowrap}
.ta-tbl tbody tr:hover{background:#f8fafc}
.ta-num{text-align:right;font-variant-numeric:tabular-nums}
.ta-badge{display:inline-grid;place-items:center;width:22px;height:22px;border-radius:6px;color:#fff;font-weight:800;font-size:12px}
.ta-pill{display:inline-block;padding:2px 9px;border-radius:20px;font-size:11.5px;font-weight:700}
.ta-empty{padding:30px;text-align:center;color:#94a3b8;font-size:14px}
.ta-bar{height:8px;border-radius:4px;background:#eef2f7;overflow:hidden;min-width:80px}
.ta-bar-f{height:100%;border-radius:4px}
.ta-sub{font-size:11.5px;color:#94a3b8;font-weight:500;margin-top:1px}
.ta-kpis{display:grid;grid-template-columns:repeat(auto-fit,minmax(210px,1fr));gap:12px;margin-bottom:12px}
.ta-kpi{background:#fff;border:1px solid #eef2f7;border-radius:14px;padding:16px 18px;box-shadow:0 1px 2px rgba(15,23,42,.04);position:relative}
.ta-kpi-l{font-size:11px;text-transform:uppercase;letter-spacing:.05em;color:#94a3b8;font-weight:700}
.ta-kpi-v{font-size:27px;font-weight:800;color:#0f172a;line-height:1.1;margin-top:6px}
.ta-kpi-s{font-size:12px;color:#64748b;margin-top:3px}
.ta-kpi-ic{position:absolute;top:14px;right:16px;width:30px;height:30px;border-radius:9px;display:grid;place-items:center;font-size:15px}
.ta-catrow{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:18px}
.ta-cat{border-radius:14px;padding:16px 18px;position:relative;border:1px solid}
.ta-cat-t{font-size:14px;font-weight:800}
.ta-cat-sub{font-size:12px;font-weight:500;opacity:.8;margin-top:1px}
.ta-cat-v{font-size:26px;font-weight:800;margin-top:10px;line-height:1}
.ta-cat-s{font-size:12px;margin-top:5px;opacity:.9;font-weight:600}
.ta-cat-ic{position:absolute;top:14px;right:16px;opacity:.55;font-size:18px}
.ta-sel{border:1px solid #e2e8f0;border-radius:9px;padding:7px 11px;font-size:13px;color:#0f172a;background:#fff;font-weight:600;cursor:pointer;outline:none}
.ta-tools{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
.ta-legends{display:flex;gap:20px;flex-wrap:wrap;margin-bottom:16px}
.ta-legend-t{font-size:12px;color:#64748b;font-weight:600;margin-bottom:5px}
.ta-legbar{display:flex;height:22px;border-radius:6px;overflow:hidden;min-width:260px}
.ta-legbar span{display:grid;place-items:center;color:#fff;font-size:11px;font-weight:700;white-space:nowrap;padding:0 6px}
.ta-tabs{display:inline-flex;background:#f1f5f9;border-radius:10px;padding:3px;gap:2px;margin-bottom:16px}
.ta-tab{border:0;background:transparent;color:#64748b;font:inherit;font-size:13.5px;font-weight:700;padding:7px 16px;border-radius:8px;cursor:pointer}
.ta-tab.on{background:#fff;color:#0f172a;box-shadow:0 1px 2px rgba(15,23,42,.1)}
.ta-matrix{display:grid;grid-template-columns:auto repeat(3,1fr);gap:8px;margin-bottom:18px;max-width:560px}
.ta-mx-h{display:grid;place-items:center;font-size:12px;font-weight:700;color:#64748b;padding:6px}
.ta-mx-c{border-radius:12px;padding:14px;text-align:center;border:1px solid}
.ta-mx-v{font-size:22px;font-weight:800;line-height:1}
.ta-mx-l{font-size:10.5px;font-weight:700;margin-top:3px;opacity:.8}
@media(max-width:640px){.ta-catrow{grid-template-columns:1fr}}
@media(max-width:700px){.ta-dp{width:100%}}
`
